import { ActionIcon, Box, Center, Flex, Title } from "@mantine/core";
import { IconArrowLeft } from "@tabler/icons-react";
import { useLocation } from "wouter";

export const Header = ({
  title,
  backButton = true,
  backLink = undefined,
  actionControl = undefined,
  actionIcon = undefined,
}: {
  title: string;
  backButton?: boolean;
  backLink?: string;
  actionControl?: React.ReactElement | false;
  actionIcon?: React.ReactElement;
}) => {
  const [, navigate] = useLocation();

  const actionElement = actionIcon ? (
    <ActionIcon variant="transparent" size="lg">
      {actionIcon}
    </ActionIcon>
  ) : (
    actionControl
  );

  return (
    <Flex align="center" justify="space-between">
      <Box style={{ flex: "0 0 auto" }}>
        {backButton && (
          <ActionIcon
            variant="transparent"
            size="lg"
            onClick={() => {
              if (backLink) {
                navigate(backLink, { replace: true });
              } else {
                window.history.back();
              }
            }}
          >
            <IconArrowLeft />
          </ActionIcon>
        )}
      </Box>

      <Box style={{ flex: "1 1 auto" }}>
        <Center>
          <Title order={3}>{title}</Title>
        </Center>
      </Box>
      {actionElement && <Box style={{ flex: "0 0 auto" }}>{actionElement}</Box>}
    </Flex>
  );
};

export const Header2 = ({ title }: { title: string }) => (
  <div>
    <ActionIcon
      variant="subtle"
      size="lg"
      onClick={() => window.history.back()}
    >
      <IconArrowLeft />
    </ActionIcon>

    <Center>
      <Title style={{ position: "absolute" }} order={3}>
        {title}
      </Title>
    </Center>
  </div>
);
